/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(async function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var index_suffix = await algolia.config.index_suffix;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;

  /**
   * FIX: `DOMContentLoaded` may already have fired by the time this async
   * IIFE resumes after `await algolia.config.index_suffix`. Attaching a
   * listener at that point means it never runs. `onReady` handles both cases.
   */
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function debounce(func, wait) {
    var timeout;
    return function() {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  var MIN_QUERY_LENGTH = 3;
  var productsIndexName = algolia.config.index_prefix + 'products' + index_suffix;

  if (document.querySelectorAll(algolia.config.collection_css_selector).length > 0) {
    var collectionPageEnabled =
      algolia.is_collection_results_page &&
      algolia.config.instant_search_enabled_on_collection;
  } else {
    var collectionPageEnabled = false;
  }

  /**
   * Which instance owns which container:
   *
   *   PRIMARY  -> collection grid (collection page) OR #search (/search page)
   *   HEADER   -> #search on every NON-search page (home, product, collection)
   *
   * The primary instance is only built when it actually has a container of
   * its own. On a home/product page it would otherwise claim `#search` and
   * fight the header instance for the same node.
   */
  var primaryEnabled = Boolean(algolia.full_results) || collectionPageEnabled;
  var headerEnabled = !algolia.full_results;

  var baseSearchFilters = []; // filters that always apply, regardless of query

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      stockPolicyFilter = 'inventory_available:true';
    }

    if (stockPolicyFilter) {
      baseSearchFilters.push(stockPolicyFilter);
    }
  }

  if (collectionPageEnabled) {
    var results_selector = algolia.config.collection_css_selector;
    if (algolia.collectionSortOrders) {
      var activeSortOrders = algolia.collectionSortOrders;
    } else {
      var activeSortOrders = algolia.sortOrders;
    }
  } else {
    var results_selector = algolia.config.results_selector;
    var activeSortOrders = algolia.sortOrders;
  }

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      routeToState: function(routeState) {
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  // Link CSS and set up CSS variables (needed by BOTH instances)
  var cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty('--main-color', algolia.config.colors.main);
  document.documentElement.style.setProperty('--secondary-color', algolia.config.colors.secondary);
  document.documentElement.style.setProperty(
    '--highlight-bg-color',
    algolia.helpers.hexToRGB(algolia.config.colors.highlight)
  );
  if (cssFile) {
    algolia.appendStyle(cssFile.text);
  }

  /**
   * FIX: these used to `throw`, which aborted the whole script — taking the
   * header search down with it on any template missing the container.
   * A missing container must never be fatal.
   */
  if (collectionPageEnabled &&
      document.querySelectorAll(algolia.config.collection_css_selector).length === 0) {
    console.warn(
      '[algolia] Collection page CSS selector not found: ' +
      algolia.config.collection_css_selector
    );
  }
  if (algolia.full_results &&
      document.querySelectorAll(algolia.config.results_selector).length === 0) {
    console.warn(
      '[algolia] Instant search CSS selector not found: ' +
      algolia.config.results_selector
    );
  }

  /* ==============================================================
   * PRIMARY INSTANCE — collection grid, or the /search page results
   * ============================================================== */
  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: productsIndexName,
      routing: {
        stateMapping: singleIndex(productsIndexName),
      },
      searchFunction: function(searchFunctionHelper) {
        var page = searchFunctionHelper.getPage();

        /**
         * FIX: the query now comes ONLY from this instance's own state.
         * It no longer reads #search_main / #search_main_desktop — those
         * inputs belong to the header instance.
         */
        var query = (searchFunctionHelper.state.query || '').trim();

        // On /search keep the 3-char minimum for non-empty queries.
        if (!collectionPageEnabled && query.length > 0 && query.length < MIN_QUERY_LENGTH) {
          return;
        }

        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', false);
        }

        /**
         * FIX: the collection scope is now UNCONDITIONAL. Previously it was
         * dropped as soon as a query existed, which turned the collection
         * grid into a full-catalog search.
         */
        var activeFilters = baseSearchFilters.slice();
        if (collectionPageEnabled && collectionFacetFilter) {
          activeFilters.push(collectionFacetFilter);
        }
        searchFunctionHelper.setQueryParameter('filters', activeFilters.join(' AND '));

        if (collectionPageEnabled && collectionRulesContextValue) {
          searchFunctionHelper.setQueryParameter('ruleContexts', [
            collectionRulesContextValue.toString(),
          ]);
        } else {
          searchFunctionHelper.setQueryParameter('ruleContexts', []);
        }

        searchFunctionHelper.setQuery(query);
        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');
  algolia.instantsearch = instant;

  /* ==============================================================
   * SHARED FACET HELPERS
   * Hoisted out of the primary block so BOTH instances can use them.
   * Every DOM lookup is scoped to a `root` element, so the header
   * instance and the collection grid can render the same class names
   * without stealing each other's containers.
   * ============================================================== */
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var makeRenderListItem = function(facetsList) {
    return function(item) {
      var facet = facetsList.find(function(f) {
        return f.name === item.label;
      });
      return item.refinements
        .map(function(refinement) {
          return (
            '<li class="ais-current-refined-values--item">' +
            '  <a ' +
            createDataAttributes(refinement) +
            '    class="ais-current-refined-values--link">' +
            '    <div>' +
            '      <div class="ais-current-refined-values--label">' +
            (facet ? facet.title : item.label) +
            '      </div>: ' +
            refinement.label +
            '    </div>' +
            '  </a>' +
            '</li>'
          );
        })
        .join('');
    };
  };

  var makeRenderCurrentRefinements = function(facetsList) {
    var renderListItem = makeRenderListItem(facetsList);
    return function(renderOptions) {
      var items = renderOptions.items;
      var refine = renderOptions.refine;
      var widgetParams = renderOptions.widgetParams;
      if (!widgetParams.container) return;

      widgetParams.container.innerHTML =
        '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div>' +
        '<div class="ais-root ais-current-refined-values ais-facet">' +
        '  <ul class="ais-current-refined-values--list">' +
        items.map(renderListItem).join('') +
        '  </ul>' +
        '</div>';

      Array.prototype.slice
        .call(
          widgetParams.container.querySelectorAll(
            '.ais-current-refined-values--link'
          )
        )
        .forEach(function(element) {
          element.addEventListener('click', function(event) {
            var item = Object.keys(event.currentTarget.dataset).reduce(
              function(acc, key) {
                var itemData = {};
                itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
                return algolia.assign({}, acc, itemData);
              },
              {}
            );

            refine(item);
          });
        });
    };
  };

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(
        function(operator) {
          return numericRefinements[operator].length > 0;
        }
      );

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  /**
   * Registers clear-refinements, current-refinements and every facet widget
   * onto `searchInstance`, looking up containers ONLY inside `root`.
   */
  function addFacetWidgets(searchInstance, root, facetsConfig) {
    var customCurrentRefinements = connectCurrentRefinements(
      makeRenderCurrentRefinements(facetsConfig.list)
    );

    var customCurrentRefinementsWithPanel = panel({
      hidden: function(options) {
        return !hasRefinements(options.helper, facetsConfig.list);
      },
    })(customCurrentRefinements);

    var clearRefinementsWithPanel = panel({
      hidden: function(options) {
        return !hasRefinements(options.helper, facetsConfig.list);
      },
    })(clearRefinements);

    var $clearContainer = root.querySelector('.ais-clear-refinements-container');
    var $currentRefContainer = root.querySelector('.ais-current-refined-values-container');

    if ($clearContainer) {
      searchInstance.addWidgets([
        clearRefinementsWithPanel({
          container: $clearContainer,
          templates: {
            resetLabel: algolia.translations.clearAll,
          },
        }),
      ]);
    }
    if ($currentRefContainer) {
      searchInstance.addWidgets([
        customCurrentRefinementsWithPanel({
          container: $currentRefContainer,
        }),
      ]);
    }

    // Hidden facets need to be declared so their values come back in results.
    var hiddenList = facetsConfig.hidden.map(function(facet) {
      return facet.name;
    });
    searchInstance.addWidgets([
      {
        getConfiguration: function() {
          return {
            facets: hiddenList,
            disjunctiveFacets: hiddenList,
          };
        },
        init: function() {},
      },
    ]);

    facetsConfig.widgets.forEach(function(widget) {
      // Resolve this facet's container inside `root` only.
      var facetClassName =
        '.ais-facet-' +
        encodeURIComponent(widget.params.attribute)
          .replace(/\./g, '\\.')
          .replace(/\%/g, '\\%');
      var parentContainer = root.querySelector(facetClassName);
      if (!parentContainer) return;

      var facetWithPanel = panel({
        hidden: function(options) {
          var hide = !hasFacetValues(options.results, widget.params.attribute);
          parentContainer.style.display = hide ? 'none' : '';
          return hide;
        },
      })(widget.widget);

      /**
       * Override the container so the widget mounts inside THIS root.
       * Prefer the widget's own original selector resolved within `root`
       * (that is what the template actually provides); only fall back to
       * the facet's parent element if that selector isn't present.
       */
      var params = Object.assign({}, widget.params);
      var resolved = null;

      if (typeof widget.params.container === 'string') {
        resolved = root.querySelector(widget.params.container);
      } else if (widget.params.container instanceof Element) {
        // Absolute node from a global lookup — re-resolve inside this root
        // by class so each instance gets its own element.
        var cls = widget.params.container.className
          .split(/\s+/)
          .filter(Boolean)
          .map(function(c) {
            return '.' + c.replace(/\./g, '\\.').replace(/\%/g, '\\%');
          })
          .join('');
        resolved = cls ? root.querySelector(cls) : null;
      }

      params.container =
        resolved ||
        parentContainer.querySelector('.ais-facet-container') ||
        parentContainer;

      searchInstance.addWidgets([facetWithPanel(params)]);
    });
  }

  function readjust() {
    if (!instant.$results) return;
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  onReady(function() {
    /* ============================================================
     * PRIMARY INSTANCE SETUP
     * ============================================================ */
    if (primaryEnabled) {
      instant.$results = document.querySelector(instant.selector);

      if (!instant.$results) {
        console.warn('[algolia] primary results container not found; skipping');
      } else {
        instant.$results.innerHTML = '';

        algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
          facets: instant.facets.list,
          multipleSortOrders: activeSortOrders.length > 1,
        });

        readjust();

        window.addEventListener('resize', function() {
          readjust();
        });

        // Mobile facets display
        instant.search.addWidgets([
          {
            init: function() {
              var $button = instant.$results.querySelector('.ais-facets-button');
              if (!$button) return; // FIX: guard
              $button.addEventListener('click', function() {
                var $facets = instant.$results.querySelector('.ais-facets');
                if (!$facets) return;

                if ($facets.classList.contains('ais-facets__shown')) {
                  $button.textContent = 'Show filters';
                  $facets.classList.remove('ais-facets__shown');
                } else {
                  $button.textContent = 'Hide filters';
                  $facets.classList.add('ais-facets__shown');
                }
              });
            },
          },
        ]);

        /**
         * FIX: guarded. This used to throw on any template without the
         * dropdown, which prevented every widget below from mounting.
         */
        var defaultHitsPerPage = instant.hitsPerPage || 16;
        var $hpp = document.getElementById('hits-per-page-dropdown');
        if ($hpp) {
          $hpp.value = defaultHitsPerPage;
        }

        instant.search.addWidgets([
          configure({
            hitsPerPage: defaultHitsPerPage,
            facetingAfterDistinct: Boolean(algolia.config.show_products),
          }),
        ]);

        if ($hpp) {
          $hpp.addEventListener('change', function(event) {
            var selectedValue = parseInt(event.target.value, 10);
            instant.search.helper
              .setQueryParameter('hitsPerPage', selectedValue)
              .search();
          });
        }

        /**
         * FIX: only the in-page search box is bound here. The header inputs
         * (#search_main / #search_main_desktop) are NO LONGER mounted on this
         * instance — that is what made typing rewrite the collection grid.
         */
        instant.search.addWidgets([
          searchBox({
            container: instant.$results.querySelector('.ais-search-box-container'),
            placeholder: algolia.translations.searchForProduct,
            showReset: false,
            showSubmit: false,
          }),
        ]);

        // Logo & clear
        instant.search.addWidgets([
          {
            init: function(opts) {
              var $clear = instant.$results.querySelector('.ais-clear-input-icon');
              if (!$clear) return; // FIX: guard
              $clear.addEventListener('click', function() {
                opts.helper.setQuery('').search();
                var input = instant.$results.querySelector('.ais-search-box--input');
                if (input) {
                  input.value = '';
                  input.focus();
                }
              });
            },
            render: function(opts) {
              var $clear = instant.$results.querySelector('.ais-clear-input-icon');
              if (!$clear) return;
              $clear.style.display = opts.state.query ? '' : 'none';
            },
          },
        ]);

        // Stats
        instant.search.addWidgets([
          stats({
            container: instant.$results.querySelector('.ais-stats-container'),
            templates: {
              text: function(data, opts) {
                return algolia.instantSearchStatsTemplate(data, opts.html);
              },
            },
          }),
        ]);

        // Sort orders
        if (activeSortOrders.length > 1) {
          instant.search.addWidgets([
            sortBy({
              container: instant.$results.querySelector('.ais-sort-orders-container'),
              items: instant.sortOrders,
            }),
          ]);
        }

        // Change display
        instant.search.addWidgets([
          {
            init: function() {
              var $blk = instant.$results.querySelector('.ais-search-header .ais-change-display-block');
              var $lst = instant.$results.querySelector('.ais-search-header .ais-change-display-list');
              if (!$blk || !$lst) return; // FIX: guard

              $blk.addEventListener('click', function() {
                var a = instant.$results.querySelector('.ais-change-display-block:not(.ais-change-display-selected)');
                var b = instant.$results.querySelector('.ais-change-display-list.ais-change-display-selected');
                var c = instant.$results.querySelector('.ais-results-as-list');
                if (a) a.classList.add('ais-change-display-selected');
                if (b) b.classList.remove('ais-change-display-selected');
                if (c) c.classList.replace('ais-results-as-list', 'ais-results-as-block');
              });

              $lst.addEventListener('click', function() {
                var a = instant.$results.querySelector('.ais-change-display-list:not(.ais-change-display-selected)');
                var b = instant.$results.querySelector('.ais-change-display-block.ais-change-display-selected');
                var c = instant.$results.querySelector('.ais-results-as-block');
                if (a) a.classList.add('ais-change-display-selected');
                if (b) b.classList.remove('ais-change-display-selected');
                if (c) c.classList.replace('ais-results-as-block', 'ais-results-as-list');
              });
            },
          },
        ]);

        // Facets: clear, current-refinements and each facet widget,
        // all resolved inside the primary results root only.
        addFacetWidgets(instant.search, instant.$results, instant.facets);

        // Hits
        instant.search.addWidgets([
          hits({
            container: instant.$results.querySelector('.ais-hits-container'),
            templates: {
              item: function(hit, opts) {
                return algolia.instantSearchProductTemplate(
                  hit,
                  opts.html,
                  opts.components
                );
              },
              empty: function(results, opts) {
                return algolia.instantSearchNoResultTemplate(opts.html);
              },
            },
            transformItems: function(items) {
              return items.map(function(item) {
                return Object.assign({}, item, {
                  _distinct: false,
                  can_order:
                    item.inventory_management !== 'shopify' ||
                    item.inventory_policy === 'continue' ||
                    item.inventory_quantity > 0,
                  queryID: item.__queryID,
                  productPosition: item.__position,
                  index: instant.search.mainIndex.getIndexName(),
                });
              });
            },
          }),
        ]);

        // Redirect to product on click
        instant.search.addWidgets([
          {
            init: function() {
              var container = instant.$results.querySelector('.ais-hits-container');
              if (!container) return;
              container.addEventListener('click', function(e) {
                var el = e.target;
                var hit;
                do {
                  if (el.matches && el.matches('.ais-hit')) {
                    hit = el;
                    break;
                  }
                  el = el.parentNode;
                } while (el && el !== container);
                if (!hit) {
                  return;
                }
                var productHandle = hit.dataset.handle;
                var variant_id = hit.dataset.variantId;
                var distinct = hit.dataset.distinct;

                var link = '';

                if (collectionPageEnabled && collectionHandle) {
                  link = window.Shopify.routes.root + 'collections/' + collectionHandle;
                  link = link + '/products/' + productHandle;
                } else {
                  link = window.Shopify.routes.root + 'products/' + productHandle;
                }

                if (distinct !== 'true') {
                  link += '?variant=' + variant_id;
                }

                if (algolia.config.analytics_enabled) {
                  var clickData = {
                    index: hit.dataset.algoliaIndex,
                    eventName: 'click',
                    queryID: hit.dataset.algoliaQueryid,
                    objectIDs: [hit.dataset.algoliaObjectid],
                  };
                  // algolia.saveForConversionTracking(clickData);
                }
                window.location.href = link;
              });
            },
          },
        ]);

        // Add to cart
        instant.search.addWidgets([
          {
            init: function() {
              var container = instant.$results.querySelector('.ais-hits-container');
              if (!container) return;
              container.addEventListener('click', function(e) {
                var el = e.target;
                var cartButton;
                do {
                  if (el.matches && el.matches('.ais-hit--cart-button')) {
                    cartButton = el;
                    break;
                  }
                  el = el.parentNode;
                } while (el && el !== container);
                if (!cartButton) {
                  return;
                }

                e.stopPropagation();
                var formId = cartButton.dataset.formId;

                if (formId && document.getElementById(formId)) {
                  document.getElementById(formId).submit();
                }
              });
            },
          },
        ]);

        // No result actions
        instant.search.addWidgets([
          {
            init: function(opts) {
              var container = instant.$results.querySelector('.ais-hits-container');
              if (!container) return;

              container.addEventListener('click', function(e) {
                var el = e.target;
                var clearFilters;
                do {
                  if (el.matches && el.matches('.ais-hit-empty--clear-filters')) {
                    clearFilters = el;
                    break;
                  }
                  el = el.parentNode;
                } while (el && el !== container);
                if (!clearFilters) {
                  return;
                }

                var helper = opts.helper;
                helper.clearTags();
                instant.facets.list.forEach(function(facet) {
                  helper.clearRefinements(facet.name);
                });
                helper.search();
              });

              container.addEventListener('click', function(e) {
                var el = e.target;
                var clearInput;
                do {
                  if (el.matches && el.matches('.ais-hit-empty--clear-input')) {
                    clearInput = el;
                    break;
                  }
                  el = el.parentNode;
                } while (el && el !== container);
                if (!clearInput) {
                  return;
                }

                opts.helper.setQuery('').search();
                var input = instant.$results.querySelector('.ais-search-box--input');
                if (input) {
                  input.value = '';
                  input.focus();
                }
              });
            },
          },
        ]);

        // Pagination
        instant.search.addWidgets([
          pagination({
            container: instant.$results.querySelector('.ais-pagination-container'),
            padding: 2,
            maxPages: 20,
          }),
        ]);

        instant.search.start();
      }
    }

    /* ============================================================
     * HEADER SEARCH INSTANCE
     * Renders ONLY into #search (algolia.config.results_selector).
     * Runs on every non-/search page — INCLUDING collection pages.
     * Always searches the full catalog.
     * ============================================================ */
    if (!headerEnabled) return;

    var $overlay = document.querySelector(algolia.config.results_selector);
    var $mobile = document.getElementById('search_main');
    var $desktop = document.getElementById('search_main_desktop');

    if (!$overlay || (!$mobile && !$desktop)) {
      return;
    }

    var header = {
      hitsPerPage: algolia.config.products_autocomplete_hits_per_page || 24,
      search: instantsearch({
        searchClient: algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
        ),
        insights: algolia.config.analytics_enabled,
        indexName: productsIndexName,

        // No `routing`: two instances writing ?q= to one URL clobber each other.

        searchFunction: function(helper) {
          var query = (helper.state.query || '').trim();
          if (query.length < MIN_QUERY_LENGTH) {
            return;
          }

          if (Boolean(algolia.config.show_products)) {
            helper.setQueryParameter('distinct', false);
          }

          // Full catalog — never collection-scoped, on any page.
          helper.setQueryParameter('filters', baseSearchFilters.join(' AND '));
          helper.setQueryParameter('ruleContexts', []);
          helper.search();
        },
      }),
    };

    header.search.client.addAlgoliaAgent('Shopify Integration');
    algolia.headerSearch = header;

    /**
     * FIX: render the FULL search UI (facets, sort, stats, hits, pagination)
     * into #search using the same template the /search page uses, instead of
     * the previous results-only markup which had no filters at all.
     */
    var headerFacets = {
      hidden: algolia.hiddenFacets,
      shown: algolia.shownFacets,
      list: algolia.facets,
      widgets: algolia.facetsWidgets,
    };

    $overlay.innerHTML = '';
    algolia.render(algolia.instantSearchMainTemplate, $overlay, {
      facets: headerFacets.list,
      multipleSortOrders: algolia.sortOrders.length > 1,
    });
    $overlay.classList.add('ais-results-size-lg');

    function scoped(sel) {
      return $overlay.querySelector(sel);
    }

    header.search.addWidgets([
      configure({
        hitsPerPage: header.hitsPerPage,
        facetingAfterDistinct: Boolean(algolia.config.show_products),
      }),

      stats({
        container: scoped('.ais-stats-container'),
        templates: {
          text: function(data, opts) {
            return algolia.instantSearchStatsTemplate(data, opts.html);
          },
        },
      }),

      hits({
        container: scoped('.ais-hits-container'),
        templates: {
          item: function(hit, opts) {
            return algolia.instantSearchProductTemplate(
              hit,
              opts.html,
              opts.components
            );
          },
          empty: function(results, opts) {
            return algolia.instantSearchNoResultTemplate(opts.html);
          },
        },
        transformItems: function(items) {
          return items.map(function(item) {
            return Object.assign({}, item, {
              _distinct: false,
              can_order:
                item.inventory_management !== 'shopify' ||
                item.inventory_policy === 'continue' ||
                item.inventory_quantity > 0,
              queryID: item.__queryID,
              productPosition: item.__position,
              index: productsIndexName,
            });
          });
        },
      }),

      pagination({
        container: scoped('.ais-pagination-container'),
        padding: 2,
        maxPages: 20,
      }),
    ]);

    // FIX: the filters. Clear-refinements, selected-filters and every facet
    // widget, all resolved inside #search only.
    addFacetWidgets(header.search, $overlay, headerFacets);

    // Sort orders
    if (algolia.sortOrders.length > 1 && scoped('.ais-sort-orders-container')) {
      header.search.addWidgets([
        sortBy({
          container: scoped('.ais-sort-orders-container'),
          items: algolia.sortOrders,
        }),
      ]);
    }

    // Mobile "Show/Hide filters" toggle inside the header panel
    header.search.addWidgets([
      {
        init: function() {
          var $button = $overlay.querySelector('.ais-facets-button');
          if (!$button) return;
          $button.addEventListener('click', function() {
            var $facets = $overlay.querySelector('.ais-facets');
            if (!$facets) return;

            if ($facets.classList.contains('ais-facets__shown')) {
              $button.textContent = 'Show filters';
              $facets.classList.remove('ais-facets__shown');
            } else {
              $button.textContent = 'Hide filters';
              $facets.classList.add('ais-facets__shown');
            }
          });
        },
      },
    ]);

    /**
     * The template ships its own .ais-search-box-container. Binding a second
     * searchBox to it keeps it in sync with the header inputs, so clearing
     * refinements or using the panel's own box behaves as expected.
     */
    if (scoped('.ais-search-box-container')) {
      header.search.addWidgets([
        searchBox({
          container: scoped('.ais-search-box-container'),
          placeholder: algolia.translations.searchForProduct,
          showReset: false,
          showSubmit: false,
        }),
      ]);
    }

    // Clear all filters / clear input from the empty-results state
    header.search.addWidgets([
      {
        init: function(opts) {
          var container = $overlay.querySelector('.ais-hits-container');
          if (!container) return;

          container.addEventListener('click', function(e) {
            var el = e.target;
            var clearFilters;
            do {
              if (el.matches && el.matches('.ais-hit-empty--clear-filters')) {
                clearFilters = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!clearFilters) return;

            var helper = opts.helper;
            helper.clearTags();
            headerFacets.list.forEach(function(facet) {
              helper.clearRefinements(facet.name);
            });
            helper.search();
          });
        },
      },
    ]);

    // Click through. Catalog-wide results, so no collection handle prefix
    // even when sitting on a collection page.
    header.search.addWidgets([
      {
        init: function() {
          var container = $overlay.querySelector('.ais-hits-container');
          if (!container) return;
          container.addEventListener('click', function(e) {
            var el = e.target;
            var hit;
            do {
              if (el.matches && el.matches('.ais-hit')) {
                hit = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!hit) return;

            var link = window.Shopify.routes.root + 'products/' + hit.dataset.handle;
            if (hit.dataset.distinct !== 'true') {
              link += '?variant=' + hit.dataset.variantId;
            }
            window.location.href = link;
          });
        },
      },
    ]);

    // Add to cart inside header results
    header.search.addWidgets([
      {
        init: function() {
          var container = $overlay.querySelector('.ais-hits-container');
          if (!container) return;
          container.addEventListener('click', function(e) {
            var el = e.target;
            var cartButton;
            do {
              if (el.matches && el.matches('.ais-hit--cart-button')) {
                cartButton = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!cartButton) return;

            e.stopPropagation();
            var formId = cartButton.dataset.formId;
            if (formId && document.getElementById(formId)) {
              document.getElementById(formId).submit();
            }
          });
        },
      },
    ]);

    header.search.start();

    // Size class for the header results panel
    function readjustHeader() {
      var width = $overlay.offsetWidth;

      var suffix = 'lg';
      if (width < 400) suffix = 'xs';
      else if (width < 800) suffix = 'sm';
      else if (width < 1200) suffix = 'md';

      $overlay.classList.remove(
        'ais-results-size-xs',
        'ais-results-size-sm',
        'ais-results-size-md',
        'ais-results-size-lg'
      );
      $overlay.classList.add('ais-results-size-' + suffix);
    }

    // ----------------------------------------------------------------
    // Show / hide the header results
    // ----------------------------------------------------------------
    var $content = document.getElementById('content');
    var $uspBar = $content ? $content.querySelector('.usp-bar-section-jtpl') : null;
    var $collectionGrid = collectionPageEnabled
      ? document.querySelector(algolia.config.collection_css_selector)
      : null;

    function setSiblingsBeforeUsp(display) {
      if (!$uspBar) return;
      var current = $uspBar.previousElementSibling;
      while (current) {
        current.style.display = display;
        current = current.previousElementSibling;
      }
    }

    function showResults() {
      $overlay.style.display = 'block';
      $overlay.style.visibility = 'visible';
      // On a collection page, hide the collection grid so the two result
      // sets never stack on top of each other.
      if ($collectionGrid) $collectionGrid.style.display = 'none';
      setSiblingsBeforeUsp('none');
      readjustHeader();
    }

    function hideResults() {
      $overlay.style.display = 'none';
      $overlay.style.visibility = 'hidden';
      if ($collectionGrid) $collectionGrid.style.display = '';
      setSiblingsBeforeUsp('block');
    }

    hideResults();

    window.addEventListener('resize', function() {
      if ($overlay.style.display === 'block') readjustHeader();
    });

    function handleInput(value) {
      var query = (value || '').trim();

      if (query.length < MIN_QUERY_LENGTH) {
        hideResults();
        header.search.helper.setQuery(''); // clear without searching
        return;
      }

      showResults();
      header.search.helper.setQuery(query).search();
    }

    // Mirror both inputs so switching breakpoint keeps the query.
    function bindInput($input, $other) {
      if (!$input) return;
      $input.addEventListener(
        'input',
        debounce(function() {
          if ($other && $other.value !== this.value) {
            $other.value = this.value;
          }
          handleInput(this.value);
        }, 300)
      );
    }

    bindInput($mobile, $desktop);
    bindInput($desktop, $mobile);

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if ($mobile) $mobile.value = '';
      if ($desktop) $desktop.value = '';
      handleInput('');
    });
  });
})(window.algoliaShopify);
